export const MaxNumbersOfSuggestions = 7;
